import Utility from "app/horoscope/utility/utility";
import React from "react";
import PropTypes from "prop-types";

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    margin: "24px 0",
    fontFamily: "sans-serif",
    fontSize: "0.8rem",
};

const thStyle = {
    background: "#f5f5f5",
    border: "1px solid #ccc",
    padding: "4px",
    fontWeight: "bold",
    textAlign: "center",
};

const tdStyle = {
    border: "1px solid #ccc",
    padding: "4px",
    textAlign: "left",
};

export default function AspectRashiTable({ aspectData }) {
    return (
        <div>
            <div style={{ textAlign: 'left', margin: '24px 0 12px 0', fontWeight: 'bold', fontSize: '0.8em' }}>
                රාශි දෘෂ්ටි
            </div>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={thStyle}>-</th>
                        <th style={thStyle}>ග්‍රහයා</th>
                        <th style={thStyle}>තැන්පත් රාශිය</th>
                        <th style={thStyle}>දෘෂ්ටි ලද රාශි</th>
                        <th style={thStyle}>දෘෂ්ටි ලද භාව</th>
                        <th style={thStyle}>දෘෂ්ටි ලද ග්‍රහයෝ</th>
                    </tr>
                </thead>
                <tbody>
                    {aspectData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyle}><p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(row.planet)}` }} /></td>
                            <td style={tdStyle}>{row.planet}</td>
                            <td style={tdStyle}>{row.rasi}</td>
                            <td style={tdStyle}>{row.aspectedRasis}</td>
                            <td style={tdStyle}>{row.aspectedHouses}</td>
                            <td style={tdStyle}>{row.aspectedPlanets}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    AspectRashiTable.propTypes = {
        aspectData: PropTypes.arrayOf(PropTypes.object).isRequired,
    };
}